import store from '@/store'

export default {
    // inserted函数：当被绑定的元素插入到 DOM 中时……
    inserted(el, binding) {
        const { value, arg } = binding  // 获取指令绑定的值;
        const permissions = store.getters.userPermissions
        if (value && value instanceof Array && value.length > 0) {
            const permissionRoles = value

            const hasPermission = permissions.some(permission => { // 只要有一个满足即返回true
                return permissionRoles.includes(permission)
            })

            // 没有该指令,直接删除掉该指令元素;即页面不显示没有指令权限的按钮;
            if (!hasPermission) {
                if (arg == "a") {
                    // 删除a标签留下文字
                    let parentNode = el.parentNode
                    let insertEl = document.createElement("span")
                    insertEl.innerHTML = el.innerHTML
                    parentNode && parentNode.replaceChild(insertEl, el)
                } else {
                    el.parentNode && el.parentNode.removeChild(el)
                    // 因项目需要，本指令remove其父元素;一般情况下，只隐藏其本身;
                }
            }
        } else {
            //throw new Error(`need roles! Like v-permission="['admin','editor']"`)
        }
    }
}